import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import plugins from "@/plugins"
import '@/filters'

Vue.config.productionTip = false

new Vue({
  ...plugins,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
